import React, { Component } from 'react';
import _ from 'lodash';
import cx from 'classnames';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import { withStyles } from '@material-ui/core/styles';
import {
    WithStyles,
    createStyles,
    Paper
} from '@material-ui/core';
import ReactPlayer from 'react-player';
import * as JSLZString from 'lz-string';
import { AudioUrlImage } from '../../constants/comman';

//styles
const styles = (theme: Theme) =>
  createStyles({
    videoAlignment: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      marginBottom: 20,
      "&>div:nth-of-typpe(1)": {
        marginRight: "auto !important",
      },
    },
    imageDisplay:{
      position:'absolute'
    }
  });

interface MyPATVideoPlayerProps extends WithStyles<typeof styles> {
    inputProps: object,
    classes: any,
    width: string,
    height: string,
    light: boolean,
    icon: HTMLElement,
    controls: boolean,
    style: object,
    videoURL: string,
    slider: boolean,
    updateThumbnailTime: Function,
    onDuration: any,
    thumbnailIcon: any;
    type:string
}

interface MyPATVideoPlayerState {
    played: number,
    seeking: boolean,
    duration: number,
}
class MyPATVideoPlayer extends Component<MyPATVideoPlayerProps, MyPATVideoPlayerState>{
    player: any
    constructor(props: MyPATVideoPlayerProps, state: MyPATVideoPlayerState) {
      super(props);
      this.state = {
            played: 0,
            seeking: false,
            duration: 0,
        };
      this.onReadyPlayer = this.onReadyPlayer.bind(this);
    }
   
    handleSeekMouseDown = (e:any) => {      
        this.setState({ seeking: true })
      }
    
      handleSeekChange =  (e:any) => {
        this.setState({ played: parseFloat(e.target.value) })
      }
    
      handleSeekMouseUp = (e:any) => {
        this.setState({ seeking: false })
        this.player.seekTo(parseFloat(e.target.value))
      }

   
  ref = (player: any) => {
    this.player = player
  }

  onReadyPlayer(e: any) {
    let videoId;
    if (window.location.href.includes('note')) {
      videoId = 'playerNoteId';
    } else {
      videoId = 'playerVideoId';
    }
    var myVideo = document.getElementById(videoId);
    if(myVideo) {
      if (myVideo.addEventListener) {
        myVideo.addEventListener('contextmenu', function (e) {
          e.preventDefault();
        }, false);
      }
    }
  }

  render(){
      const { played } = this.state
      const {
        classes,
        width,
        height,
        light,
        icon,
        controls,
        style,
        videoURL,
        updateThumbnailTime = () => {},
        slider,
        thumbnailIcon,
        onDuration = () => {},
        ...inputProps
    } = this.props;
    let videoIdN;
    if (window.location.href.includes('note')) {
      videoIdN = 'playerNoteId';
    } else {
      videoIdN = 'playerVideoId';
    }
    let newVideoURL = JSLZString.decompressFromEncodedURIComponent(videoURL);
    return (
        <>
        <div className={cx(classes.videoAlignment)} id={videoIdN}>
          {
            this.props.type === 'Audio' &&
            <>
             <img className={classes.imageDisplay} src={AudioUrlImage}/>
            </>
          }
           <ReactPlayer url={newVideoURL? newVideoURL : ''} 
             controls={(typeof controls === 'boolean') ? controls: true} //not working with- controls && true
             width={width} 
             height={height}
             light={light? thumbnailIcon :false}
             playIcon={icon}
             ref={this.ref}
             style={ style ? style : {}}
             onSeek={(e: any) => updateThumbnailTime(e)}
             onDuration={onDuration}
             onReady={(e:any) => this.onReadyPlayer(e)}
             config={{ file: { attributes: { controlsList: 'nodownload' } } }}
            />
             </div>
            {
                slider ? <Paper elevation={3}>
                <input
                    style={{'width':'-webkit-fill-available'}}
                    type='range' min={0} max={0.999999} step='any'
                    value={played}
                    onMouseDown={this.handleSeekMouseDown}
                    onChange={this.handleSeekChange}
                    onMouseUp={this.handleSeekMouseUp}
                  />
                </Paper> : ''
            }
            </>
    );
  }
};
// @ts-ignore
export default withStyles(styles)(MyPATVideoPlayer);